import { render, staticRenderFns } from "./WikiPageList.vue?vue&type=template&id=9f264aa8"
import script from "./WikiPageList.vue?vue&type=script&lang=ts"
export * from "./WikiPageList.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports